import type { MajorStatus, MinorStatus } from "@citrine/types/status";

import type { StatusDetail } from "../common";
import type { DataSourceID } from "../data-source";
import type { ResourceBase } from "../modules/common";

export interface DesignWorkflow extends Omit<
  ResourceBase,
  "status" | "status_description"
> {
  id: string;
  name: string;
  description?: string;
  branch_id?: string;
  branch_root_id?: string;
  design_space_id?: string | null;
  predictor_id?: string | null;
  predictor_version?: number | string | null;
  processor_id?: string | null;
  data_source_id?: DataSourceID | null;
  status?: MajorStatus;
  status_description?: MinorStatus;
  status_detail?: StatusDetail[];
  module_type?: "DESIGN_WORKFLOW";
  type?: "DesignWorkflow";
}

export const isDesignWorkflowFailed = (workflow?: DesignWorkflow): boolean =>
  workflow?.status === "FAILED";

export const isDesignWorkflowReady = (workflow?: DesignWorkflow): boolean =>
  workflow?.status_description === "READY" || workflow?.status === "SUCCEEDED";

export const isDesignWorkflowValidating = (
  workflow?: DesignWorkflow,
): boolean =>
  workflow?.status_description === "CREATED" ||
  workflow?.status_description === "VALIDATING";
